import { Component } from '@angular/core';
import { OnInit } from '@angular/core';

@Component({
  selector: 'cat-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  copyrightYears: any;

  constructor() {}

  ngOnInit() {
    this.copyrightYears = new Date().getFullYear();
  }

}


